import { render, staticRenderFns } from "./DeviceAssignmentList.vue?vue&type=template&id=15eb76b0&scoped=true&"
import script from "./DeviceAssignmentList.vue?vue&type=script&lang=ts&"
export * from "./DeviceAssignmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb76b0",
  null
  
)

export default component.exports